import { useEffect, useState, type ReactNode } from "react";
import { useLocale } from "../i18n/provider.js";
import { platform } from "../platform/index.js";

/**
 * **زرُّ تثبيت التطبيق، ومؤشّرُ انقطاع الشبكة.**
 *
 * ولافتتاهما مكتوبتان في القاموس منذ المرحلة الأولى — `shell.install`
 * و`shell.offline` — **ولا تُقرآن من أي شاشة**. وهما دليلُ ميزتين صُمِّمتا ولم
 * تُبنيا، لا نصّان زائدان: فالتثبيتُ معيارُ قبولٍ معلَن، **ومؤشّرُ الانقطاع من
 * أساسيّات تطبيقٍ مثبَّت** يُفتَح في الشارع.
 *
 * **والزرُّ لا يُرسَم إلا حين يعرض المتصفّحُ التثبيتَ فعلاً**: فزرٌّ يُضغَط ولا
 * يحدث شيء أسوأ من زرٍّ غائب. ومن ثبّته لا يراه ثانيةً — المتصفّحُ لا يُطلق
 * الحدثَ أصلاً.
 */

export function InstallBar(): ReactNode {
  const { t } = useLocale();
  const [offline, setOffline] = useState(() => platform.isOffline());
  const [installable, setInstallable] = useState(false);

  useEffect(() => platform.onConnectivityChange(setOffline), []);
  useEffect(() => platform.onInstallAvailable(setInstallable), []);

  if (!offline && !installable) return null;

  return (
    <>
      {/**
       * **والانقطاعُ يُقال فوق كل شيء** — فمن يرى شاشةً لا تستجيب يظنّ العطبَ
       * فينا، ويعيد المحاولة، ويفقد ما كتب. وجملةٌ واحدة تمنع ذلك كلَّه.
       */}
      {offline ? (
        <div className="offline" role="status" aria-live="polite">
          {t("shell.offline")}
        </div>
      ) : null}

      {installable ? (
        <div className="install-bar">
          <span>{t("shell.installWhy")}</span>
          <button
            type="button"
            className="btn sm"
            onClick={() => {
              void platform.promptInstall();
            }}
          >
            {t("shell.install")}
          </button>
        </div>
      ) : null}
    </>
  );
}
